import useJwt from '@/auth/jwt/useJwt'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  return localStorage.getItem('userData') && localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
  // return localStorage.getItem('userData') && localStorage.getItem('accessToken')
}

export const getUserData = () => {
  try {
    return JSON.parse(localStorage.getItem('userData'))
  } catch {
    return null
  }
}

/** Display label for navbar profile dropdown and similar UI. */
export function resolveUserDisplayName(user) {
  if (!user) return 'User'

  const candidates = [
    user.name,
    user.fullName,
    [user.f_name, user.l_name].filter(Boolean).join(' '),
    [user.firstname, user.lastname].filter(Boolean).join(' '),
    user.contact_person_name,
    user.compny_name,
    user.company_name,
    user.username,
    user.email,
  ]

  const match = candidates.find(value => String(value || '').trim())
  return match ? String(match).trim() : 'User'
}

export function resolveUserRoleLabel(user) {
  if (!user) return 'Admin'
  const role = user.roleName || user.role
  if (typeof role === 'string' && role.trim()) return role.trim()
  if (role && typeof role === 'object') {
    return role.name || role.label || 'Admin'
  }
  return 'Admin'
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = () => {
  if (localStorage.getItem('userData')) return '/'
  return { name: 'auth-login' }
}
